import cepSpy from 'cep-spy';

export function startCepSpy() {
  // // 主要信息
  // console.error('=== Adobe CEP 扩展信息 ===');
  // console.error('当前宿主:', cepSpy.appName); // 输出: PHXS (Photoshop), ILST (Illustrator), etc.
  // console.error('宿主版本:', cepSpy.appVersion); // 输出: 24.0.0, 19.0, etc.
  // console.error('应用区域设置:', cepSpy.appLocale); // 输出: en_US, zh_CN, etc.
  // console.error('CEP 版本:', cepSpy.cepVersion); // 输出: 9.4.0, etc.
  // console.error('用户代理:', cepSpy.userAgent); // 输出: Windows, Mac, etc.
  // console.error('扩展 ID:', cepSpy.extID); // 输出: com.example.extension
  // console.error('扩展名称:', cepSpy.extName); // 输出: Extension Name
  // console.error('扩展版本:', cepSpy.extVersion); // 输出: 1.0.0
  // console.error('用户 ID:', cepSpy.userId); // 输出: 用户ID或空字符串
  // // 开发模式信息
  // console.error('\n=== 开发模式信息 ===');
  // console.error('是否为开发模式:', cepSpy.isDev); // 输出: true/false
  // console.error('本地服务器地址:', cepSpy.localhost); // 输出: http://localhost:8081
  // // 路径信息
  // console.error('\n=== 系统路径信息 ===');
  // console.error('扩展根目录:', cepSpy.path.root);
  // console.error('用户数据目录:', cepSpy.path.userData);
  // console.error('公共文件目录:', cepSpy.path.commonFiles);
  // console.error('我的文档目录:', cepSpy.path.myDocuments);
  // console.error('宿主应用程序路径:', cepSpy.path.hostApplication);
  // // 包信息
  // console.error('\n=== 包信息 ===');
  // console.error('包名称:', cepSpy.package && cepSpy.package.name);
  // console.error('包版本:', cepSpy.package && cepSpy.package.version);
  // console.error('包描述:', cepSpy.package && cepSpy.package.description);
  // console.error('作者:', cepSpy.package && cepSpy.package.author);
  // console.error('仓库:', cepSpy.package && cepSpy.package.repository);
  // console.error('主页:', cepSpy.package && cepSpy.package.homepage);
  // // 主机能力
  // console.error('\n=== 主机能力 ===');
  // console.error('禁用 Flash 扩展:', cepSpy.hostCapabilities.DISABLE_FLASH_EXTENSIONS);
  // console.error('扩展面板图标:', cepSpy.hostCapabilities.EXTENDED_PANEL_ICONS);
  // console.error('支持 HTML 扩展:', cepSpy.hostCapabilities.SUPPORT_HTML_EXTENSIONS);
  // console.error('委托 APE 引擎:', cepSpy.hostCapabilities.DELEGATE_APE_ENGINE);
  // console.error('扩展面板菜单:', cepSpy.hostCapabilities.EXTENDED_PANEL_MENU);
  // // 当前扩展详细信息
  // console.error('\n=== 当前扩展详细信息 ===');
  // console.error('主路径:', cepSpy.ext && cepSpy.ext.mainPath);
  // console.error('最大高度:', cepSpy.ext && cepSpy.ext.maxHeight);
  // console.error('最大宽度:', cepSpy.ext && cepSpy.ext.maxWidth);
  // console.error('窗口类型:', cepSpy.ext && cepSpy.ext.windowType);
  // console.error('基础路径:', cepSpy.ext && cepSpy.ext.basePath);
  // console.error('默认高度:', cepSpy.ext && cepSpy.ext.height);
  // console.error('默认宽度:', cepSpy.ext && cepSpy.ext.width);
  // console.error('最小高度:', cepSpy.ext && cepSpy.ext.minHeight);
  // console.error('最小宽度:', cepSpy.ext && cepSpy.ext.minWidth);
  // // 活动扩展信息
  // console.error('\n=== 活动扩展信息 ===');
  // console.error('活动扩展主路径:', cepSpy.activeExt && cepSpy.activeExt.mainPath);
  // console.error('活动扩展名称:', cepSpy.activeExt && cepSpy.activeExt.name);
  // console.error('活动扩展 ID:', cepSpy.activeExt && cepSpy.activeExt.id);
  // // 扩展数量
  // console.error('\n=== 扩展统计 ===');
  // console.error('总扩展数量:', (cepSpy.exts && cepSpy.exts.length) || 0);
  // // 获取所有扩展信息
  // console.error('\n=== 所有扩展列表 ===');
  // if (cepSpy.getAllExtensions) {
  //   const allExtensions = cepSpy.getAllExtensions();
  //   if (allExtensions && allExtensions.length > 0) {
  //     allExtensions.forEach((ext, index) => {
  //       console.error(`扩展 ${index + 1}:`);
  //       console.error(`  ID: ${ext.id}`);
  //       console.error(`  名称: ${ext.name}`);
  //       console.error(`  版本: ${ext.version}`);
  //       console.error(`  窗口类型: ${ext.windowType}`);
  //       console.error(`  基础路径: ${ext.basePath}`);
  //       console.error('---');
  //     });
  //   } else {
  //     console.error('  没有找到其他扩展');
  //   }
  // } else {
  //   console.error('  getAllExtensions 方法不可用');
  // }
  // // 获取特定扩展信息示例
  // console.error('\n=== 当前扩展详细数据 ===');
  // if (cepSpy.getExtData) {
  //   const currentExtData = cepSpy.getExtData(cepSpy.extID);
  //   console.error('当前扩展完整信息:', currentExtData);
  // } else {
  //   console.error('getExtData 方法不可用');
  // }
  // // 主题和样式相关（如果存在）
  // console.error('\n=== 主题信息 ===');
  // console.error('主题:', cepSpy.theme || '未定义');
  // console.error('主题颜色:', cepSpy.themeColor || '未定义');
  // // 项目特定信息
  // console.error('\n=== 项目特定信息 ===');
  // console.error('作者:', cepSpy.author);
  // console.error('仓库地址:', cepSpy.repository);
  // console.error('主页地址:', cepSpy.homepage);
  // // 错误处理示例
  // console.error('插件版本:', cepSpy.extVersion);
  // console.error('警告信息示例');
  // console.error('信息提示示例');
  // // 安全检查
  // console.error('\n=== 安全检查 ===');
  // console.error('CEP API 可用:', typeof window.__adobe_cep__ != 'undefined');
  // console.error('文件系统可用:', typeof cepSpy.path.root != 'undefined');
}
// 获取插件版本方法
export function getPluginVersion() {
  return cepSpy.extVersion;
}
// 获取插件版本方法
export function getTenantId() {
  // cep-spy 初始化时已自动读取 package.json，直接取即可
  const pkg = cepSpy.package;
  console.error('版本:', pkg.id);
  return pkg.id || '519766'; // 插件版本来自 manifest.xml
}
// 判定租户
export function isMarmot() {
  let tenantId = getTenantId();
  return String(tenantId) !== '519766'; // 判断是否为 marmot 租户
}



// WEBPACK FOOTER //
// ./src/utils/cepspy.js